import { render, staticRenderFns } from "./ApplicationReview.vue?vue&type=template&id=05af849b&scoped=true&"
import script from "./ApplicationReview.vue?vue&type=script&lang=ts&"
export * from "./ApplicationReview.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationReview.vue?vue&type=style&index=0&id=05af849b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af849b",
  null
  
)

export default component.exports